import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'star-icon',
  templateUrl: './star-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class StarIconComponent {}
